import React from 'react';
import { makeAutoObservable } from 'mobx';
import { Pivot, PivotItem, Spinner } from '@fluentui/react';
import { EntityAPI, EntityType, IEntityColumn, IGenericEntity, IUserConfigPackage } from '../../API';
import { observer } from 'mobx-react';
import EntityProperties, { EntityPropertiesState } from './EntityProperties';
import EntityFileBrowser, { EntityFileBrowserState } from './EntityFileBrowser';
import { ReusableDialogState } from './ReusableDialog';

export class EntityDetailsState {
	public item?: IGenericEntity;
	public entityType?: string | EntityType;
	public userConfig: IUserConfigPackage;
	public columns?: IEntityColumn[];

	public dialogState: ReusableDialogState;
	public loaded: boolean = false;
	public loading: boolean = false;

	public constructor(userConfig: IUserConfigPackage) {
		makeAutoObservable(this);
		this.userConfig = userConfig;	
		this.dialogState = new ReusableDialogState('', 800);
	}

	public show(entityType: string | EntityType, item: IGenericEntity, columns?: IEntityColumn[]) {
		this.loaded = false;
		this.entityType = entityType;
		this.item = item;
		this.columns = columns;

		let allProperties = Object.getOwnPropertyNames(item);
		let codeProp = allProperties.find(p => p.endsWith('Code'));
		let code = '';
		if (codeProp) {
			code = (item as any)[codeProp];
		}

		this.dialogState.setTitle(item.DisplayTitle);
		this.dialogState.setMiniTitle(code);
		this.dialogState.setWidth('80%');
		this.dialogState.setOnDismiss(() => this.dismiss());
		this.dialogState.setVisible(true);
	}

	public dismiss() {
		this.item = undefined;
		this.columns = undefined;
		this.entityType = undefined;
	}

	public async ensureLoaded() : Promise<void> {
		if(!this.loaded && this.entityType && this.item) {

			this.setLoading(true);

			//Only need to load columns if they're missing
			if(!this.columns) {
				//Load columns from the API
				const api = await EntityAPI.fromEntityTypeOrId(this.entityType, this.userConfig);
				this.columns = await api.columns();
			}

			this.setLoading(false);
			this.setLoaded(true);
		}
	}

	public setLoaded(loaded: boolean) {
		this.loaded = loaded;
	}

	public setLoading(loading: boolean) {
		this.loading = loading;
	}
}

export interface IEntityDetailsProps {
	state: EntityDetailsState;
}

class EntityDetails extends React.Component<IEntityDetailsProps> {

	componentDidMount() {
		this.props.state.ensureLoaded();
	}

	render() {

		if(this.props.state.loading) {
			return <Spinner />;
		}

		if(this.props.state.columns && this.props.state.item && this.props.state.entityType) {

			return (
				<>
					<Pivot>
						<PivotItem headerText="Overview">
							<EntityProperties state={new EntityPropertiesState(this.props.state.userConfig, this.props.state.columns, this.props.state.item)} />
						</PivotItem>
						<PivotItem headerText="Files">
							<EntityFileBrowser state={new EntityFileBrowserState(this.props.state.userConfig, this.props.state.entityType, this.props.state.item)} />
						</PivotItem>
					</Pivot>
				</>
			);
		} else {
			return <></>;
		}
	}

}

export default observer(EntityDetails);
